import React from 'react'
import { IconSeekers } from 'ui-seeker/core'

import { USER_ROLE } from 'app/@common/constants'
import { getAppUserData } from 'app/@utils'
import './userroleicon.css'


// Icon of the logged-in session: master → two figures, solid blue;
// any other user → one figure, light. Both keep the inherited size.
export default function AppUserRoleIcon() {

    const { role } = getAppUserData()

    if (role === USER_ROLE.MASTER)
        return <IconSeekers icon='user-friends' iconType='fontAwesome' iconWeight='fas' className='user-role-icon user-role-icon--master' />
    return <IconSeekers icon='user' iconType='fontAwesome' iconWeight='fal' className='user-role-icon user-role-icon--user' />
}
